import React from "react";
import clsx from "clsx";
import styles from "./SegmentedButton.module.scss";
export function SegmentedButton({ options, onButtonClick, label }) {
    return (React.createElement("div", { className: styles.container },
        label && React.createElement("span", { className: clsx(styles.label, "label-medium") }, label),
        React.createElement("div", { className: styles.buttonGroup }, options.map(({ text, isActive }, i) => (React.createElement("button", { key: text, type: "button", className: clsx("label-medium", styles.button, isActive && styles.active), onClick: () => onButtonClick(i) }, text))))));
}
